import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Alert, Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import './style.scss';

import SingleBarChart from './BarChart';
import PeriodBarChart from './PeriodBarChart';
import NewPieChart from './NewPieChart';
import PieChartPro from './PieChartPro';
import StackedBarChartPro from './StackedBarChartPro';
import StackedBarChartProB from './StackedBarChartProB';
import StackedBarChartProGroup from './StackedBarChartProGroup';
import StackedBarChartProReverseGroup from './StackedBarChartProReverseGroup';
import axios from "axios";

import TableHead from "../common/TableHead";
import useResponsive from "../../../customHooks/useResponsive";
import TableHeadMini from "../common/TableHeadMini";

const OrderRevenueCharts = () => {

    const dispatch = useDispatch();

    const { isMobile } = useResponsive();

    const [RevenueData, setRevenueData] = useState({});

    const [totalRevenueData, setTotalRevenueData] = useState([]);
    const [totalQtyPieData, setTotalQtyPieData] = useState([]);

    const [periodWiseData, setPeriodWiseData] = useState([]);

    const [revenueTotal, setRevenueTotal] = useState('');

    const [sort, setSortState] = useState("revenue_by_month_wise");
    const [searchData, setSearchData] = useState({ product_id: '', po_number: '', designer_code: '' });
    const [onSearchText, setSearchText] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);

    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);


    const searchDropdownValue = useSelector((state) => state.commonReducer.searchDropdownValue);

    const getRevenuesData = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/order-revenue`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const refetchRevenueData = useMutation(getRevenuesData, {
        onSettled(data, error) {
            if (data) {                
                setRevenueData(data?.data?.finalResponse)
            }
        }
    })


    const searchRevenueData = async (params) => {
        
        let startDate = typeof params.startDate !== "undefined" && params.startDate !== "Invalid date" ? params.startDate : "";
        let endDate = typeof params.endDate !== "undefined" && params.endDate !== "Invalid date" ? params.endDate : "";
        let category_id = params?.category_id?.value ? params?.category_id?.value : '';
        let sub_category = params?.sub_category?.value ? params?.sub_category?.value : '';        
        let order_type = params?.order_type?.value ? params?.order_type?.value : '';        

        try {
            const { data } = await loginAxios.get(`dashboard/order-revenue?from_date=${startDate}&to_date=${endDate}&category_id=${category_id}&sub_category_id=${sub_category}&order_type=${order_type}`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;

        } catch (error) {
            return Promise.reject(error);
        }
    };

    const searchRevenueDataCall = useMutation(searchRevenueData, {
        onSettled(data, error) {
            if (data) {                
                setRevenueData(data?.data?.finalResponse)
            }
        }
    })






    const getCategoryList = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/category/drp?action=category&level=1&parentId[]=1&isStatus=1`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const getCategoryListCall = useMutation(getCategoryList, {
        onSettled(data, error) {
            if (data) {                
                let collectArr = data?.data?.list.map((item) => {
                    return {
                        value: item.categoryID,
                        label: item.categoryTitle,
                    };
                });
                setCategoryList(collectArr)
            }
        }
    });




    const getSubCategoryList = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/category/drp?action=category&level=2&parentId[]=${param}&isStatus=1`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const getSubCategoryListCall = useMutation(getSubCategoryList, {
        onSettled(data, error) {
            if (data) {                
                let collectArr = data?.data?.list.map((item) => {
                    return {
                        value: item.categoryID,
                        label: item.categoryTitle,
                    };
                });
                setSubCategoryList(collectArr)
            }
        }    
    });


useEffect(() => {
    refetchRevenueData.mutate();
    getCategoryListCall.mutate();    
}, []);

useEffect(() => {    
    if(searchDropdownValue != '') {
        getSubCategoryListCall.mutate(searchDropdownValue);
    }    
}, [searchDropdownValue])


useEffect(() => {
    if (RevenueData?.revenue_array?.length > 0) {
        let totalRev = RevenueData?.revenue_array.map(item => {
            return {
                name: item.rev_type,
                value: item.tot_rev
            };
        });
        setTotalRevenueData(totalRev);


        let totalVal = RevenueData?.revenue_array?.reduce((total, item) => {            
            return total + item.tot_rev
        }, 0);

        setRevenueTotal(totalVal.toLocaleString('en-IN'));

    }
    if (RevenueData?.revenue_array?.length > 0) {
        let totalRev = RevenueData?.revenue_array.map(item => {
            return {
                name: item.rev_type,
                value: item.tot_qty
            };
        });
        setTotalQtyPieData(totalRev);
    }




    if (RevenueData?.revenue_by_month_wise?.length > 0) {
        sortPeriodData('revenue_by_month_wise');
    }


}, [RevenueData]);


const sortPeriodData = (str) => {    
    let totalRev = RevenueData?.[`${str}`].map(item => {
        return {
            data1: item.id,
            data1Lable: item.totalRevenue
        };
    });    
    setPeriodWiseData(totalRev);
}


const handleChangePeriod = (txt) => {
    setSortState(txt);
    sortPeriodData(txt);
}

const searchHandler = async (data) => {    
    searchRevenueDataCall.mutate(data);
};


let seachFeild = {
    // po_number: '',        
    category_id: '',
    sub_category: '',
    order_type: '',
};


const orderTypeArr = [
    {label: 'Stores', value: 'stores'},
    {label: 'Online', value: 'online'},
    {label: 'Both', value: 'both'},
]

const seachFeildType = {

    po_number: {
        tag: "input",
        type: "text",
    },
    category_id: {
        tag: "dropdown",
        options: categoryList,
        optionName: 'Category'
    },

    sub_category: {
        tag: "dropdown",
        options: subCategoryList,
        optionName: 'Sub Category'
    },
    order_type: {
        tag: "dropdown",
        options: orderTypeArr,
        optionName: 'Order Type'
    },    
};


const handleGetData = () => {
    setSearchData({ product_id: '', po_number: '', designer_code: '' });
    refetchRevenueData.mutate();
}

return (<>

    <Head title="Order Revenue Charts"></Head>

    <Content>
        <BlockHead size="sm">
            <BlockBetween>
                <BlockHeadContent>
                    <BlockTitle>Revenue Reports</BlockTitle>
                    <ul className="list list-sm" id="list-note">
                        <li>This tab contains your business revenue of the last 12 months </li>
                        <li>You can choose specific category and subcategory with date ranges from the filters given, to see the desired view. You can also choose to see daily, weekly & monthly views of the revenue bar graph </li>
                        <li>All graphs use the customer order-date as reference</li>                        
                        <li>Revenue is calculated basis PO price</li>                        
                      </ul>
                </BlockHeadContent>
            </BlockBetween>
        </BlockHead>

        <Block>

            {/* <TableHead
                searchHandler={searchHandler}
                searchFieldData={seachFeild}
                seachFeildType={seachFeildType}
                reloadHandler={() => {
                    handleGetData();
                }}
                setSearchText={setSearchText}
                setSelectedItems={setSelectedItems}
                pageName="order-revenue-chart"
                showDatePicker={true}
                showSearchBar={false}
            /> */}



                {isMobile &&
                  <TableHeadMini
                    searchHandler={searchHandler}
                    searchFieldData={seachFeild}
                    seachFeildType={seachFeildType}
                    reloadHandler={() => {
                      handleGetData();
                    }}
                    setSearchText={setSearchText}
                    setSelectedItems={setSelectedItems}
                    pageName="order-revenue-chart"
                /> }

          {!isMobile && <TableHead
            searchHandler={searchHandler}
            searchFieldData={seachFeild}
            seachFeildType={seachFeildType}
            reloadHandler={() => {
              handleGetData();
            }}
            setSearchText={setSearchText}
            setSelectedItems={setSelectedItems}
            pageName="order-revenue-chart"
          />}

            <Row>


                <Col md="6">
                    <Card className="card-stretch mt-2 p-3">
                        <h5 style={{ textDecoration: 'underline' }}>Revenue Breakup</h5>
                        {(searchRevenueDataCall?.isLoading || refetchRevenueData?.isLoading) ?
                            <div style={{ textAlign: 'center' }}>
                                <Spinner size="xl" color="light" />
                            </div>
                            :
                            <div className="card-inner-group">
                                <PieChartPro mapData={totalRevenueData || []} total={revenueTotal} />
                            </div>
                        }
                    </Card>
                </Col>

                {/* <Col md="6">
                        <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Total Inward</h5>
                            <div className="card-inner-group">
                                <PeriodBarChart data={periodWiseData} />                                
                            </div>
                        </Card>
                    </Col> */}


                <Col md="6">
                    <Card className="card-stretch mt-2  p-3">
                        <div>
                            <h5 style={{ textDecoration: 'underline', display: 'inline-block' }}>Revenue Over Time</h5>

                            {(searchRevenueDataCall?.isLoading || refetchRevenueData?.isLoading) ?
                            <div style={{ textAlign: 'center' }}>
                                <Spinner size="xl" color="light" />
                            </div>
                            :
                            <>
                            <div className="card-tools mr-n1" style={{ alignItems: 'center', display: 'inline-block', float: 'right' }}>
                                <ul className="btn-toolbar">
                                    <li>
                                        <UncontrolledDropdown>
                                            <DropdownToggle
                                                tag="a"
                                                href="#toggle"
                                                onClick={(ev) => ev.preventDefault()}
                                                className="link link-light link-sm dropdown-indicator"
                                                style={{ fontSize: '16px' }}
                                            >
                                                {sort == "revenue_by_day_wise" && 'Daily'}
                                                {sort == "revenue_by_week_wise" && 'Weekly'}
                                                {sort == "revenue_by_month_wise" && 'Monthly'}
                                                {/* {sort == "revenue_by_week_wise" ? 'Oldest first' : 'Newest First'} */}
                                            </DropdownToggle>

                                            <DropdownMenu right className="dropdown-menu-xs">

                                                <ul className="link-check chart-ul-items">
                                                    {/* <li>
                                                        <span>Order</span>
                                                    </li> */}
                                                    <li className={sort === "revenue_by_day_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangePeriod("revenue_by_day_wise");
                                                            }}
                                                        >
                                                            Daily
                                                        </DropdownItem>
                                                    </li>
                                                    <li className={sort === "revenue_by_week_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangePeriod("revenue_by_week_wise");
                                                            }}
                                                        >
                                                            Weekly
                                                        </DropdownItem>
                                                    </li>


                                                    <li className={sort === "revenue_by_month_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangePeriod("revenue_by_month_wise");
                                                            }}
                                                        >
                                                            Monthly
                                                        </DropdownItem>
                                                    </li>
                                                </ul>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </li>
                                </ul>
                            </div>

                            <div className="card-inner-group">
                                <SingleBarChart data={periodWiseData} />
                            </div>
                            </>
                            }
                        </div>

                    </Card>
                </Col>


                <Col md="6">
                    <Card className="card-stretch mt-2 p-3">
                        <h5 style={{ textDecoration: 'underline' }}>Best Selling Products</h5>
                        {(searchRevenueDataCall?.isLoading || refetchRevenueData?.isLoading) ?
                            <div style={{ textAlign: 'center' }}>
                                <Spinner size="xl" color="light" />
                            </div>
                            :
                            <div className="card-inner-group" style={{height: '450px', overflowY: 'scroll'}}>

                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">Product Title</th>
                                            <th scope="col">Designer Code</th>                                            
                                            <th scope="col">Total Revenue</th>
                                            <th scope="col">Total Qty.</th>
                                            <th scope="col">Product Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {RevenueData?.product_array?.map((data) => {
                                            return (
                                                <tr>                                                    
                                                    <td><a href={`${data?.product_url}`} target="_blank" >
                                                        <span>{data?.productTitle}</span>
                                                    </a>                                                        
                                                    </td>                                                    
                                                    <td>{data?.designerCode}</td>

                                                    <td>{data?.revTotal?.toLocaleString('en-IN')}</td>
                                                    <td>{data?.qtyTotal}</td>
                                                    <td>{data?.product_status}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </Card>
                </Col>




                <Col md="6">
                    <Card className="card-stretch mt-2 p-3">
                        <h5 style={{ textDecoration: 'underline' }}>Category</h5>
                        {(searchRevenueDataCall?.isLoading || refetchRevenueData?.isLoading) ?
                            <div style={{ textAlign: 'center' }}>
                                <Spinner size="xl" color="light" />
                            </div>
                            :
                            <div className="card-inner-group">

                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">Category</th>
                                            <th>Sub Cat.</th>
                                            {/* <th scope="col">Category Qty.</th> */}
                                            {/* <th scope="col">Category Revenue</th> */}
                                            <th scope="col">Qty. %</th>
                                            <th scope="col">Qty. Total</th>
                                            <th scope="col">Rev. %</th>
                                            <th scope="col">Rev. Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {RevenueData?.category_array?.map((data) => {
                                            return (
                                                <tr>
                                                    <td>{data?.cat}</td>
                                                    <td>{data?.subCat}</td>
                                                    {/* <td>{data?.catQty}</td> */}
                                                    {/* <td>{data?.catRev}</td> */}
                                                    <td>{data?.qtyPercent}</td>
                                                    <td>{data?.qtyTotal}</td>
                                                    <td>{data?.revPercent}</td>
                                                    <td>{data?.revTotal?.toLocaleString('en-IN')}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </Card>
                </Col>

            </Row>
        </Block>
    </Content>

    <ToastContainer />
</>)
};

export default OrderRevenueCharts;